import { setSearchText } from '../../../redux/slices/table'

export const onEnterSearch = (e, handleSearch) => (dispatch) => {
  if (e.charCode === 13) {
    handleSearch(e.target.value)
    dispatch(setSearchText(e.target.value))
  }
}
